import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { PartnerCTA } from '../components/PartnerCTA';
export function CookiePolicyPage() {
  return <>
      <PageHero title="Cookie Policy" data-id="element-726" />

      <Breadcrumbs items={[{
      label: 'Cookie Policy'
    }]} data-id="element-727" />

      <section className="bg-white py-24" data-id="element-728">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-729">
          <p data-id="element-730">Last updated: February 2025</p>
          <h3 data-id="element-731">What Are Cookies?</h3>
          <p data-id="element-732">
            Cookies are small text files that are placed on your computer or
            mobile device by websites that you visit. They are widely used in
            order to make websites work, or work more efficiently, as well as to
            provide information to the owners of the site.
          </p>
          <h3 data-id="element-733">How We Use Cookies</h3>
          <p data-id="element-734">Chiltern Global uses cookies to:</p>
          <ul data-id="element-735">
            <li data-id="element-736">
              Understand how you use our website (e.g. which pages you visit).
            </li>
            <li data-id="element-737">Remember your preferences.</li>
            <li data-id="element-738">Improve your experience on our site.</li>
          </ul>
          <h3 data-id="element-739">Managing Cookies</h3>
          <p data-id="element-740">
            Most web browsers allow some control of most cookies through the
            browser settings. To find out more about cookies, including how to
            see what cookies have been set and how to manage and delete them,
            visit www.aboutcookies.org or www.allaboutcookies.org.
          </p>
        </div>
      </section>

      <PartnerCTA data-id="element-741" />
    </>;
}